import { FaFacebookF, FaInstagram, FaTwitter, FaTiktok } from 'react-icons/fa';
import { FiPhone, FiMail } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Subscribe from './Subscribe';
import useAdSense from '../hooks/useAdSense';

const Footer = () => {
  useAdSense();

  return (
    <footer className="bg-footer text-white py-10">
      <div className="container mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start mb-6">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h3 className="text-2xl font-bold mb-2 font-poppins">Stay Connected</h3>
            <p className="text-sm font-poppins">Follow me on social media for the latest updates and insights!</p>
            <div className="flex space-x-4 mt-4">
              <a href="https://www.facebook.com/confessionsofanutritionfreak?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer">
                <FaFacebookF className="text-white hover:text-gray-300 transition duration-300" size={24} />
              </a>
              <a href="https://www.instagram.com/ConfessionsofaNutritionFreak" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="text-white hover:text-gray-300 transition duration-300" size={24} />
              </a>
              <a href="https://x.com/Confessionfreak?mx=2" target="_blank" rel="noopener noreferrer">
                <FaTwitter className="text-white hover:text-gray-300 transition duration-300" size={24} />
              </a>
              <a href="https://www.tiktok.com/@nutritionconfessions" target="_blank" rel="noopener noreferrer">
                <FaTiktok className="text-white hover:text-gray-300 transition duration-300" size={24} />
              </a>
            </div>
          </div>

          <div className="mt-6 md:mt-0">
            <h3 className="text-lg font-bold mb-2 font-poppins">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white hover:text-gray-300 transition duration-300 font-poppins">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-gray-300 transition duration-300 font-poppins">About</Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-white hover:text-gray-300 transition duration-300 font-poppins">Testimonials</Link>
              </li>
              <li>
                <Link to="/blog" className="text-white hover:text-gray-300 transition duration-300 font-poppins">Blog</Link>
              </li>
              <li>
                <Link to="/contact" className="text-white hover:text-gray-300 transition duration-300 font-poppins">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="mt-6 md:mt-0">
            <h3 className="text-lg font-bold mb-2 font-poppins">Contact Info</h3>
            <div className="flex items-center space-x-2 mb-2">
              <FiPhone className="text-white" size={20} />
              <span className="text-sm font-poppins">+254 797647753</span>
            </div>
            <div className="flex items-center space-x-2">
              <FiMail className="text-white" size={20} />
              <span className="text-sm font-poppins">mwendekivale@gmail.com</span>
            </div>
          </div>
        </div>

        <Subscribe />

        <div className="border-t border-gray-300 pt-4 text-center">
          <p className="text-sm font-poppins">
            Made with <span className="text-red-500">❤️</span> by{' '}
            <a href="https://www.linkedin.com/in/karen-nzilani-loti-338041215/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition duration-300">Karen</a> &{' '}
            <a href="https://www.linkedin.com/in/michael-orwa-950102161" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-300 transition duration-300">Michael Orwa</a>.
          </p>
          <p className="text-sm font-poppins">&copy; {new Date().getFullYear()} Confessions of a Nutrition Freak. All rights reserved.</p>
        </div>
      </div>
      {/* adsense script */}
      <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
      <div>
        {/* Your other content */}
        <ins className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-8626961699894922"
          data-ad-slot="8626961699894922"
          data-ad-format="auto"></ins>
        {/* Your other content */}
      </div>
    </footer>
  );
};

export default Footer;
